const secondaryWindowId = new Date().getTime();
sessionStorage.setItem("secondaryWindowId", secondaryWindowId);

const tmp = window.location.href;
if (tmp.indexOf("woveb2c") > -1) {
  const container = document.getElementsByTagName("base")[0];
  container.href = "/woveb2c/";
}
else if (getEnvironment() === "Localhost") {
  const container = document.getElementsByTagName("base")[0];
  container.href = "/";
}
else {
  const container = document.getElementsByTagName("base")[0];
  container.href = "/wove/";
}
function getEnvironment() {
  const url = window.location.href;
  switch (true) {
    case url.indexOf(".dev.") > -1:
      return "DEV";
    case url.indexOf("localhost") > -1:
      return "Localhost";
    case url.indexOf(".test.") > -1:
      return "TEST";
    case url.indexOf("xat-") > -1:
      return "QA";
    default:
      return "PROD";
  }
}

// <!--App Dynamics script-- >
window["adrum-config"] = {
  userEventInfo: {
    "PageView": function (context) {
      return {
        userData: {
          userId: sessionStorage.getItem("userId"),
          appId: sessionStorage.getItem("appId")
        }
      }
    },
    "Ajax": function (context) {
      return {
        userData: {
          userId: sessionStorage.getItem("userId"),
          appId: sessionStorage.getItem("appId")
        }
      }
    },
    "VPageView": function (context) {
      return {
        userData: {
          userId: sessionStorage.getItem("userId"),
          appId: sessionStorage.getItem("appId")
        }
      }
    }
  }
};

// BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET-->

const Qenv = getEnvironment();

if (Qenv === "PROD") {

  (function(){var g=function(e,h,f,g){
    this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
    this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
    this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
    this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
    this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
    try{(new g(100,"r","QSI_S_ZN_3PdH9t3J7o09LYG","https://zn3pdh9t3j7o09lyg-pershing.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3PdH9t3J7o09LYG")).start()}catch(i){}})();
    
} else {

  (function(){var g=function(e,h,f,g){
    this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
    this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
    this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
    this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
    this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
    try{(new g(100,"r","QSI_S_ZN_3PdH9t3J7o09LYG","https://zn3pdh9t3j7o09lyg-pershing.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3PdH9t3J7o09LYG&Q_VERSION=0")).start()}catch(i){}})();   
    
}


//needed for testing locally
if (location.hostname.includes("localhost") &&
  !location.pathname.includes("account") &&
  !location.pathname.includes("client") &&
  !location.pathname.includes("group") &&
  !location.pathname.includes("advisor") &&
  !location.pathname.includes("proposal") &&
  !location.pathname.includes("custom-trading")
) {
  window.name = "default";
}

function getDomainByEnv() {
  const url = window.location.href;
  switch (true) {
    case url.indexOf(".dev.") > -1:
      return "https://qa-app-woveplatform.test.bnymellon.net";
    case url.indexOf("uat-") > -1:
      return "https://uat-app-woveplatform.test.bnymellon.net";
    case url.indexOf(".test.") > -1:
      return "https://qa-app-woveplatform.test.bnymellon.net";
    case url.indexOf("xat") > -1:
      return "https://xat-app-woveplatform.bnymellon.com";
    default:
      return "https://app.woveplatform.com";
  }
}

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
if (params.contextType) {
  const tmpGetDupVal = sessionStorage.getItem("noDups");
  if (tmpGetDupVal == "1") {
    location.href = 'https://mysource2.bnymellon.net/';
  }
  sessionStorage.setItem("noDups", "1");
} else {
  sessionStorage.removeItem('noDups');
}
const env = getEnvironment();
const head = document.getElementsByTagName('head')[0];
const OtAutoBlockScript = document.createElement("script");
OtAutoBlockScript.type = "text/javascript";

const otSDKStubScript = document.createElement("script");
otSDKStubScript.type = "text/javascript";
otSDKStubScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
otSDKStubScript.charset = "UTF-8";

if (env === "PROD") {
  otSDKStubScript.setAttribute("data-domain-script", "0196ca97-9a9b-72a1-b3a3-40ade633277c");
  OtAutoBlockScript.src = "https://cdn.cookielaw.org/consent/0196ca97-9a9b-72a1-b3a3-40ade633277c/OtAutoBlock.js ";
} else {
  otSDKStubScript.setAttribute("data-domain-script", "0196ca97-9a9b-72a1-b3a3-40ade633277c-test");
  OtAutoBlockScript.src = "https://cdn.cookielaw.org/consent/0196ca97-9a9b-72a1-b3a3-40ade633277c-test/OtAutoBlock.js";
}

head.appendChild(OtAutoBlockScript);
head.appendChild(otSDKStubScript);

let intljs = "";
let shimjs = "";
let polyfilljs = "";
let refjs = "";
if (env === "PROD") { //Prod

  intljs = "https://www.pllcfiles.com/staticartifacts/thirdparty/intl@1.2.5/dist/Intl.min.js";
  shimjs = "https://www.pllcfiles.com/staticartifacts/thirdparty/core-js@2.4.1/client/shim.min.js";
  polyfilljs = "https://www.pllcfiles.com/staticartifacts/thirdparty/element.scrollintoviewifneeded-polyfill@1.0.1/index.js";
  refjs = "https://www.pllcfiles.com/staticartifacts/thirdparty/reflect-metadata@0.1.3/Reflect.js";

} else if (env === "QA") {//XAT
  intljs = "https://xat-www.pllcfiles.inautix.com/staticartifacts/thirdparty/intl@1.2.5/dist/Intl.min.js";
  shimjs = "https://xat-www.pllcfiles.inautix.com/staticartifacts/thirdparty/core-js@2.4.1/client/shim.min.js";
  polyfilljs = "https://xat-www.pllcfiles.inautix.com/staticartifacts/thirdparty/element.scrollintoviewifneeded-polyfill@1.0.1/index.js";
  refjs = "https://xat-www.pllcfiles.inautix.com/staticartifacts/thirdparty/reflect-metadata@0.1.3/Reflect.js";

} else {//QA

  intljs = "https://qa-www.pllcfiles.inautix.com/staticartifacts/thirdparty/intl@1.2.5/dist/Intl.min.js";
  shimjs = "https://qa-www.pllcfiles.inautix.com/staticartifacts/thirdparty/core-js@2.4.1/client/shim.min.js";
  polyfilljs = "https://qa-www.pllcfiles.inautix.com/staticartifacts/thirdparty/element.scrollintoviewifneeded-polyfill@1.0.1/index.js";
  refjs = "https://qa-www.pllcfiles.inautix.com/staticartifacts/thirdparty/reflect-metadata@0.1.3/Reflect.js";

}
const intljsTag = document.createElement("script");
setAttributes(intljsTag, { "type": "text/javascript", "src": intljs });
const shimjsTag = document.createElement("script");
setAttributes(shimjsTag, { "type": "text/javascript", "src": shimjs });
const polyfilljsTag = document.createElement("script");
setAttributes(polyfilljsTag, { "type": "text/javascript", "src": polyfilljs });
const refjsTag = document.createElement("script");
setAttributes(refjsTag, { "type": "text/javascript", "src": refjs });
head.appendChild(intljsTag);
head.appendChild(shimjsTag);
head.appendChild(polyfilljsTag);
head.appendChild(refjsTag);

function setAttributes(el, attrs) {
  Object.entries(attrs).forEach(([key, value]) => void el.setAttribute(key, value));
}